import RestaurantTitle from './RestaurantTitle';

export default RestaurantTitle;
